import React, { useEffect, useState } from "react";
import Nav from "../master/NavBar";
import { closeModal, SweetAlertShow, LoadingDiv } from "../master/Master";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Header from "../master/SideBar";
import usePrivateLink from "../config/usePrivateLink";
import {
  librariesList,
  libraryStudentDelete,
  libraryStudentList,
  libraryStudentStatusChange,
  libraryStudentUpdate,
} from "../../api/Library";
import Pagination from "../components/Pagination";
import LibraryLayout from "./LibraryLayout";

export default function LibraryStudents() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [libraries, setLibraries] = useState([]);
  const [students, setStudents] = useState([]);
  const [modalData, setModalData] = useState({});
  const [filters, setFilters] = useState({});

  const getLibraryList = async () => {
    setLoading(true);
    let addUrl = `status=1`;
    try {
      const response = await librariesList(addUrl);
      if (response.data?.status) {
        setLibraries(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getLibraryStudents = async () => {
    setLoading(true);
    let addUrl = "";
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value) {
        addUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    try {
      const response = await libraryStudentList(addUrl);
      if (response.data?.status) {
        setStudents(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getLibraryList();
  }, []);

  useEffect(() => {
    getLibraryStudents();
  }, [filters]);

  const updateLibraryStudent = async (e) => {
    setLoading(true);
    e.preventDefault();

    try {
      const formData = new FormData(e.target);
      const response = await libraryStudentUpdate(formData);
      if (response?.data?.status) {
        closeModal("editStudent");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getLibraryStudents();
    }
  };

  const updateLibraryStudentStatus = async (id, end_date) => {
    try {
      const response = await libraryStudentStatusChange(id, end_date);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getLibraryStudents();
    }
  };

  const deleteLibraryStudent = async (id) => {
    setLoading(true);
    try {
      const response = await libraryStudentDelete(id);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getLibraryStudents();
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row py-5">
                  <LibraryLayout />
                  <div className="col-12">
                    <div className="card my-3">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                          <h4 className="text-primary mb-0">Students</h4>
                          {hasAccess("/library/student/add") && (
                            <Link
                              to={"/library/student/add"}
                              className="btn btn-label-primary btn-sm"
                            >
                              + Add New Student
                            </Link>
                          )}
                        </div>
                        <div className="row align-items-center">
                          <div className="col-md-3 col-sm-6 mb-3">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="library_id"
                                id="library_id"
                                className="form-select"
                                value={filters?.library_id}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    library_id: e.target.value,
                                  })
                                }
                              >
                                <option value="">All</option>
                                {libraries?.map((library, i) => (
                                  <option value={library?.id}>
                                    {library?.name}
                                  </option>
                                ))}
                              </select>
                              <label htmlFor="library_id">
                                {" "}
                                Select Library{" "}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3 col-sm-6 mb-3">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                name="search"
                                placeholder="Search"
                                value={filters?.search}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    search: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="search">Search </label>
                            </div>
                          </div>
                          <div className="col-md-2 ">
                            <button
                              type="button"
                              onClick={() => {
                                setFilters({ page: 1 });
                              }}
                              className="btn btn-sm btn-label-danger"
                            >
                              <i className="ri ri-restart-line"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card my-3">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-sm">
                            <thead>
                              <tr className="text-center text-nowrap">
                                <th>#</th>
                                <th>Student</th>
                                <th>Father name</th>
                                <th>Mobile no</th>
                                <th>Address</th>
                                <th>Joining Date</th>
                                <th>Library</th>
                                <th>Seat No</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {students?.data?.map((student, index) => (
                                <tr key={student?.id}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {student?.student_name} (
                                    {student?.registration_no})
                                  </td>
                                  <td>{student?.father_name}</td>
                                  <td>{student?.mobile}</td>
                                  <td>{student?.address}</td>
                                  <td>{student?.joining_date}</td>
                                  <td>{student?.library?.name}</td>
                                  <td>
                                    {student?.seat?.seat_no} (
                                    {student?.shift?.name}){" "}
                                  </td>
                                  <td>
                                    <button
                                      className={`btn badge ${
                                        student?.status === "1"
                                          ? "bg-success"
                                          : "bg-danger text-white"
                                      }`}
                                      disabled={student?.status === "2"}
                                      onClick={async () => {
                                        if (student?.status === "1") {
                                          const today = new Date()
                                            .toISOString()
                                            .split("T")[0];

                                          const { value: end_date } =
                                            await Swal.fire({
                                              title: "Mark as Inactive",
                                              text: "Select end date to mark this student as Inactive",
                                              icon: "warning",
                                              input: "date",
                                              inputLabel: "End Date",
                                              inputValue: today,
                                              showCancelButton: true,
                                              confirmButtonColor: "#3085d6",
                                              cancelButtonColor: "#d33",
                                              confirmButtonText:
                                                "Yes, Inactivate it!",
                                              inputValidator: (value) => {
                                                if (!value) {
                                                  return "You need to select a date!";
                                                }
                                              },
                                            });

                                          if (end_date) {
                                            updateLibraryStudentStatus(
                                              student?.id,
                                              end_date,
                                            );
                                          }
                                        }
                                      }}
                                    >
                                      {student?.status === "1"
                                        ? "Active"
                                        : "Inactive"}
                                    </button>
                                  </td>

                                  <td>
                                    {hasAccess("/library/student/profile") && (
                                      <Link
                                        to={`/library/student/profile?id=${student.id}`}
                                        className="dropdown-item"
                                      >
                                        <button className="btn btn-label-info btn-sm me-2 mb-2">
                                          <i className="bi bi-eye text-success "></i>
                                        </button>
                                      </Link>
                                    )}

                                    {hasAccess("/library/student/update") && (
                                      <button
                                        onClick={() => {
                                          setModalData(student);
                                        }}
                                        className="btn btn-label-info btn-sm me-2 mb-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editStudent"
                                      >
                                        <i className="bi bi-pencil-square"></i>{" "}
                                      </button>
                                    )}
                                    {hasAccess("/library/student/delete") && (
                                      <button
                                        className="btn btn-label-danger btn-sm me-2"
                                        onClick={() =>
                                          Swal.fire({
                                            title: "Are you sure?",
                                            text: "This action will permanently delete !",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#d33",
                                            cancelButtonColor: "#6c757d",
                                            confirmButtonText:
                                              "Yes, delete it!",
                                            cancelButtonText: "Cancel",
                                          }).then(async (result) => {
                                            if (result.isConfirmed) {
                                              deleteLibraryStudent(student?.id);
                                            }
                                          })
                                        }
                                      >
                                        <i className="bi bi-trash-fill"></i>{" "}
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          <Pagination
                            data={students}
                            setFilters={setFilters}
                            filters={filters}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editStudent"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={updateLibraryStudent}>
              <div className="modal-header bg-label-primary py-3">
                <h3 className="modal-title fs-5" id="exampleModalLabel">
                  Edit Student
                </h3>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row g-3 p-3">
                  <input type="hidden" name="id" value={modalData?.id} />
                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control input-capitalize"
                      placeholder="Student Name"
                      name="student_name"
                      defaultValue={modalData?.student_name}
                    />
                    <label className="">Student Name</label>
                  </div>
                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Student Registration No"
                      name="registration_no"
                      required
                      defaultValue={modalData?.registration_no}
                    />
                    <label className="">Registration No</label>
                  </div>

                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control input-uppercase"
                      placeholder="Father Name"
                      name="father_name"
                      defaultValue={modalData?.father_name}
                    />
                    <label className="">Father Name</label>
                  </div>

                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Contact Number"
                      name="mobile"
                      defaultValue={modalData?.mobile}
                    />
                    <label className="">Contact No</label>
                  </div>

                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control input-uppercase"
                      placeholder="Address"
                      name="address"
                      defaultValue={modalData?.address}
                    />
                    <label className="">Address</label>
                  </div>

                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Joining Date"
                      name="joining_date"
                      defaultValue={modalData?.joining_date}
                    />
                    <label className="">Joining Date</label>
                  </div>
                </div>
              </div>

              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
